import React from "react";
import { useTranslation } from "react-i18next";
import { InputWrapper } from "../../../../components/Input/InputWrapper";
import { InputLabel } from "../../../../components/Input/InputLabel";
import {
  FieldGrid,
  FieldGroup,
  ReadOnlyField,
} from "../../../../components/OrgShell/FieldGroup";
import { ShippingSection } from "../../../customer-update/component/sections/shipping-section.component";
import { DetailsForm } from "../../../customer-create/components/organization-details-form.component";

interface VendorDetailsSectionProps {
  form: DetailsForm;
  onChange: (form: DetailsForm) => void;
  navNumber?: string;
  shippingDiffers: boolean;
  onShippingDiffersChange: (differs: boolean) => void;
}

/**
 * The vendor's own company details: read-only company fields (they are
 * managed in the ERP system) plus the editable shipping address that keeps
 * the existing save round-trip.
 */
export function VendorDetailsSection({
  form,
  onChange,
  navNumber,
  shippingDiffers,
  onShippingDiffersChange,
}: VendorDetailsSectionProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-8">
      <FieldGroup
        title={t("myProfileCore.companyDetailsTitle")}
        description={t("myProfileCore.companyDetailsDescription")}
      >
        <FieldGrid>
          <InputWrapper>
            <InputLabel>{t("myProfileCore.companyName")}</InputLabel>
            <ReadOnlyField value={form.name} />
          </InputWrapper>
          <InputWrapper>
            <InputLabel>{t("myProfileCore.navNumber")}</InputLabel>
            <ReadOnlyField value={navNumber} />
          </InputWrapper>
          <InputWrapper>
            <InputLabel>{t("myProfileCore.companyEmail")}</InputLabel>
            <ReadOnlyField value={form.email} />
          </InputWrapper>
          <InputWrapper>
            <InputLabel>{t("myProfileCore.companyPhone")}</InputLabel>
            <ReadOnlyField value={form.phone} />
          </InputWrapper>
          <InputWrapper>
            <InputLabel>{t("myProfileCore.cvr")}</InputLabel>
            <ReadOnlyField value={form.cvr} />
          </InputWrapper>
        </FieldGrid>
      </FieldGroup>

      <FieldGroup title={t("myProfileCore.address")}>
        <FieldGrid>
          <InputWrapper>
            <InputLabel>{t("myProfileCore.address")}</InputLabel>
            <ReadOnlyField value={form.address} />
          </InputWrapper>
          <div className="grid grid-cols-2 gap-x-4">
            <InputWrapper>
              <InputLabel>{t("myProfileCore.postcode")}</InputLabel>
              <ReadOnlyField value={form.postCode} />
            </InputWrapper>
            <InputWrapper>
              <InputLabel>{t("myProfileCore.city")}</InputLabel>
              <ReadOnlyField value={form.city} />
            </InputWrapper>
          </div>
          <InputWrapper>
            <InputLabel>{t("myProfileCore.country")}</InputLabel>
            <ReadOnlyField value={form.country} />
          </InputWrapper>
        </FieldGrid>
      </FieldGroup>

      <ShippingSection
        form={form}
        onChange={(patch) => onChange({ ...form, ...patch })}
        differs={shippingDiffers}
        onDiffersChange={onShippingDiffersChange}
      />
    </div>
  );
}
